export default __webpack_public_path__ + "1c5ef3b8927d56b47ab799fc46b629c0.png";